import React from "react";
import { Text } from "@showitinc/showit-wc";

import StatePropertiesInfo from "./StatePropertiesInfo";
import BackgroundProperties from "./BackgroundProperties";
import AppConstants from "../constants/AppConstants";
import BlockUpdateVO from "../vo/BlockUpdate";
import { batchPropChanges, formatPropNames } from "./utils/PropsUpdater";
import DocumentStore from "../document/DocumentStore";
import { COMMANDS } from "../document/commands";

const { BLOCK_WP_POST, BLOCK_ID, BLOCK_NAME, BLOCK_SLUG, BLOCK_TYPE, BLOCK_WP } = AppConstants;

const StateProperties = ({ block, state, stateId, layout }) => {
  const onPropUpdate = (propInfo) => {
    const blockId = block.get(BLOCK_ID);
    const update = new BlockUpdateVO();
    const nameFormatter = (propName) => `${stateId}.${propName}`;
    const updaterCB = ({ name, action = null, value, addUndo = false, source }) => {
      const pathParts = name.split(".");
      update.add(blockId, pathParts, value, action, addUndo, source);
    };
    const formattedProps = formatPropNames(propInfo, nameFormatter);

    batchPropChanges(formattedProps, updaterCB);
    DocumentStore.dispatch({ type: COMMANDS.UPDATE_BLOCK, payload: update });
  };

  const wpFeaturedAllowed = block.getIn([BLOCK_WP, BLOCK_TYPE], false) === BLOCK_WP_POST;

  return (
    <div>
      <StatePropertiesInfo
        stateId={stateId}
        name={state.get(BLOCK_NAME)}
        slug={state.get(BLOCK_SLUG)}
      />
      <Text className="panel-subheading">Background</Text>
      <BackgroundProperties
        wpFeaturedAllowed={wpFeaturedAllowed}
        videoAllowed
        layout={layout}
        parent={state}
        onPropUpdate={onPropUpdate}
      />
    </div>
  );
};

export default StateProperties;
